<template>
    <div class="last-masterclass-container">
        <div class="video-wrapper">
            <div class="video-container">
                <div class="video-title">Resumen masterclass extraordinaria ActivoTrade</div>
                <iframe 
                    src="https://player.vimeo.com/video/1082464748?h=3fd2279e00&amp" 
                    width="100%" 
                    height="600" 
                    frameborder="0" 
                    allowfullscreen>
                </iframe>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LastMasterclass'
}
</script>

<style scoped>
.last-masterclass-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    padding: 15px;
    background-color: #f5f5f5;
}

.video-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 95%;
    max-width: 1400px;
}

.video-container {
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    padding: 20px;
    text-align: center;
    width: 100%;
}

.video-title {
    background-color: #0f0f1a;
    color: white;
    padding: 12px 20px;
    margin-bottom: 15px;
    border-radius: 8px;
    font-weight: bold;
    font-size: 18px;
}

iframe {
    border-radius: 8px;
    max-width: 100%;
    height: auto;
}

.loading-container {
    text-align: center;
    padding: 40px;
    font-size: 18px;
    color: #666;
}

/* Responsive design */
@media screen and (min-width: 1200px) {
    iframe {
        height: 700px;
    }
}

@media screen and (max-width: 1199px) and (min-width: 900px) {
    iframe {
        height: 500px;
    }
}

@media screen and (max-width: 899px) {
    iframe {
        width: 100%;
        height: 400px;
    }
    
    .video-container {
        padding: 15px;
    }
    
    .video-title {
        font-size: 16px;
        padding: 10px 15px;
    }
    
    .video-wrapper {
        width: 98%;
    }
}

@media screen and (max-width: 600px) {
    iframe {
        height: 300px;
    }
    
    .last-masterclass-container {
        padding: 10px;
    }
    
    .video-wrapper {
        width: 100%;
    }
}
</style> 